import { useLocationProperty } from "wouter/use-browser-location";

export function useLocationHash() {
  return useLocationProperty(() => window.location.hash);
}
